import { render, staticRenderFns } from "./lottery-analysis.vue?vue&type=template&id=b27ed7ec&scoped=true"
import script from "./lottery-analysis.vue?vue&type=script&lang=ts"
export * from "./lottery-analysis.vue?vue&type=script&lang=ts"
import style0 from "./lottery-analysis.vue?vue&type=style&index=0&id=b27ed7ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27ed7ec",
  null
  
)

export default component.exports